import type { Components, Theme } from '@mui/material';
import { fontWeights } from '@/@mui/tokens/font-weights';

export const MuiInputLabel: Components<Theme>['MuiInputLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.neutral.darker,
      fontWeight: fontWeights.fontWeightSemibold,
      marginBottom: theme.spacing(1),

      '&.Mui-focused': {
        color: theme.palette.neutral.darker,
      },
    }),
  },
};
